var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"height":"100%"}},[_c('app-bar',{staticClass:"mr-4 mr-md-10"}),_c('v-main',[_c('v-container',{staticClass:"px-md-10 pt-5",attrs:{"fluid":"","id":"MyContainerTopFull"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }